module.exports = __webpack_public_path__ + "media/smile-1.b27dfe89.mp3";